import { Experience, PaginatedResponse } from "@bullseye/types"

import { useUserContext } from "../providers"
import { usePaginatedRequest } from "./useRequest"

type Params = Record<string, string>

export const useUserExperiences = (userId: string, params?: Params) => {
  const { accessToken } = useUserContext()

  return usePaginatedRequest<PaginatedResponse<Experience>>({
    path: `v1/users/${userId}/experiences`,
    params,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })
}
